import {
  GET_DRESOURCES,
  CREATE_DRESOURCES,
  DELETE_DRESOURCE,
  EDIT_DRESOURCE,
} from 'actions/actionTypes';
import { IDResourcesState, IDResource } from 'types';

interface ActionType {
  type:
    | 'GET_DRESOURCES'
    | 'CREATE_DRESOURCES'
    | 'DELETE_DRESOURCE'
    | 'EDIT_DRESOURCE'
    | 'DRESOURCE_ERROR';
  payload: {
    unitId: number;
    resources: IDResource[];
    resourceId?: number;
    error?: string | null;
    updated?: IDResource;
  };
}

const initialState: IDResourcesState = {
  units: {},
};

const dResources = (
  state = initialState,
  action: ActionType
): IDResourcesState => {
  switch (action.type) {
    case CREATE_DRESOURCES: {
      const { unitId, resources } = action.payload;
      const { units } = state;

      const newRes = resources[0];
      units[unitId]?.push(newRes);

      return {
        ...state,
      };
    }
    case GET_DRESOURCES: {
      const { unitId, resources } = action.payload;
      const { units } = state;

      resources
        .sort((a, b) => {
          return a.id - b.id;
        })
        .sort((a, b) => {
          return b.ownerType === 'event' ? -1 : 0;
        });

      const updated = {
        ...units,
        [unitId]: resources,
      };

      return {
        units: updated,
      };
    }
    case EDIT_DRESOURCE: {
      const { unitId, updated } = action.payload;
      const { units } = state;
      const res = units[unitId];

      if (updated && res) {
        const index = res.findIndex((r) => r.id === updated.id);
        res.splice(index, 1, updated);
      }

      return {
        ...state,
      };
    }
    case DELETE_DRESOURCE: {
      const { unitId, resourceId } = action.payload;
      const { units } = state;

      const removed = units[unitId].filter((r) => r.id !== resourceId);
      const updated = { ...units, [unitId]: removed };

      return {
        units: updated,
      };
    }
    default:
      return state;
  }
};

export default dResources;
